import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import {Dog} from '../../../classes/dog';
import config from '../../../config';
import {MembershipType} from "../../../classes/membershipType";

@Injectable()
export class kanMembershipService {
    constructor(private http: HttpClient) {
    }

    public getTypes(): Promise<MembershipType[]> {
        return this.http.get(`${config.apiRootUrl}/api/membershipTypes`)
            .toPromise()
            .then((response: any) => {
                return response.sort((item1, item2) => {
                    return item1.type < item2.type ? -1 : item1.type > item2.type ? 1 : 0;
                }) as MembershipType[];
            })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/modules/services/services/membership.ts